<template>
  <component :is="props.as">
    <slot
      v-if="props.skeleton"
      name="skeleton"
    >
      <SkeletonText :breakpoints-width="props.skeletonBreakpoints" />
    </slot>

    <slot v-else>
      {{ props.text }}
    </slot>
  </component>
</template>

<script setup lang="ts">
  import { SkeletonText } from '@experience/core-skeleton-lib';
  import type { TTextProps } from './types';

  const props = withDefaults(defineProps<TTextProps>(), {
    as: 'span',
  });
</script>

<style scoped lang="scss"></style>
